import { useForm } from 'react-hook-form'

import { SelectFormComponent } from '@/modules/shared/components/select-form.component'
import { Button } from '@/modules/shared/components/ui/button'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from '@/modules/shared/components/ui/dialog'
import { Form } from '@/modules/shared/components/ui/form'

import { useOrderFormStore } from '../../../stores/order-form.store'

type ModalSelectCompanyFormData = {
	companyId: string
}

interface IModalSelectCompanyComponent {
	isOpen: boolean
	onClose: () => void
	onSelectCompany: (companyId: string) => void
}

export function ModalCompanySelectionComponent({
	isOpen,
	onClose,
	onSelectCompany,
}: IModalSelectCompanyComponent) {
	const form = useForm<ModalSelectCompanyFormData>()

	const { paramsOrderForm } = useOrderFormStore()

	const submitCompany = (data: { companyId: string }) => {
		onSelectCompany(data.companyId)
		onClose()
	}

	return (
		<Dialog open={isOpen} onOpenChange={onClose}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>Empresa</DialogTitle>
				</DialogHeader>
				<Form {...form}>
					<form onSubmit={form.handleSubmit(submitCompany)}>
						<SelectFormComponent<ModalSelectCompanyFormData>
							control={form.control}
							label="Empresas"
							name="companyId"
							options={paramsOrderForm?.listaParametros?.map((item) => {
								return {
									value: item.fkEmpresa.toString(),
									label: item.siglaEmpresa,
								}
							})}
						/>

						<Button className="mt-3" type="submit">
							Salvar
						</Button>
					</form>
				</Form>
			</DialogContent>
		</Dialog>
	)
}
